import type { NavigationTranslations } from "types/visioweb/navigation";
import type { Localizations } from "~/service/l10n";

export const translations: Localizations = {
  en: {
    continue: "Continue",
    error_title: "Something went wrong",
    info_title: "How to use the map",
    info_text: 
      `Search for a store or select your destination straight from the map. Then select 
      the store closest to you and click the Show route button. Browse the routing 
      instructions to reach your destination.`,
    loading: "Loading…",
    not_routable_poi: `Unfortunately no route can be found to the destination!`,
    overlay_instruction: "Double tap to interact with the map!",
    route_compute: "Searching route…",
    route: "Route",
    route_option_accessible: "Accessible",
    route_option_shortest: "Shortest",
    route_node_dst: "Destination",
    route_node_dst_hint: `Where do you want to go to?`,
    route_node_src: "Starting point",
    route_node_src_hint: 
      `Choose a store i.e. close to your current location. Search or pick a location from the map.`,
    route_node_src_showmap: "Show map",
    route_not_available: "Unfortunately, the route was not successful!",
    route_show: "Show route",
    search: "Search…",
    show_location: "Show location",
  },
};

export const visio: NavigationTranslations = {
  maneuvers: {
    unknown: '<unknown>',
    goStraight: 'Go straight',
    turnGentleRight: 'Turn gentle right',
    turnGentleLeft: 'Turn gentle left',
    turnRight: 'Turn right',
    turnLeft: 'Turn left',
    turnSharpRight: 'Turn sharp right',
    turnSharpLeft: 'Turn sharp left',
    UTurnRight: 'Make right U-turn',
    UTurnLeft: 'Make left U-turn',
    start: 'Start',
    end: 'You have arrived',
    goUp: 'Go up to floor %L',
    goDown: 'Go down to floor %L',
    changeModality: 'Use transportation mode: %M',
    changeLayer: 'Change building',
    waypoint: 'Stop'
  },
  nextManeuvers: {
    unknown: '<unknown>',
    goStraight: 'go straight',
    turnGentleRight: 'turn gentle right',
    turnGentleLeft: 'turn gentle left',
    turnRight: 'turn right',
    turnLeft: 'turn left',
    turnSharpRight: 'turn sharp right',
    turnSharpLeft: 'turn sharp left',
    UTurnRight: 'make right U-turn',
    UTurnLeft: 'make left U-turn',
    start: 'start',
    end: 'you have arrived',
    goUp: 'go up',
    goDown: 'go down',
    changeModality: 'change transportation mode: %M',
    changeLayer: 'change building',
    waypoint: 'stop'
  },
  keywords: {
    for: ' for ',
    then: ' then ',
    and: ' and ',
    near: ' near ',
    using: ' using ',
    stairway: 'the stairway',
    escalator: 'the escalator',
    lift: 'the lift',
  },
  durations: {
    seconds: 'a few seconds',
    oneMinute: 'about a minute',
    minutes: 'about %d minutes',
  }
}
